// import React, { useEffect, useState } from "react";
// import styled from "styled-components";
// import { useNavigate } from "react-router-dom";

// export default function GoogleCalendarCallback() {
//   const navigate = useNavigate();
//   const [status, setStatus] = useState("processing");
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const hash = window.location.hash.substring(1);
//     const params = new URLSearchParams(hash);
//     const accessToken = params.get("access_token");

//     if (!accessToken) {
//       setStatus("error");
//       setError("Access token not found. Permission denied or cancelled.");
//       return;
//     }

//     createTestCalendarEvents(accessToken);
//   }, []);

//   const createTestCalendarEvents = async (token) => {
//     try {
//       const DAYS_TO_CREATE = 3; // 🔥 testing ke liye
//       const createdEvents = [];

//       for (let i = 0; i < DAYS_TO_CREATE; i++) {
//         const start = new Date();
//         start.setDate(start.getDate() + i);
//         start.setHours(7, 30, 0, 0); // 7:30 AM fixed for testing

//         const end = new Date(start);
//         end.setMinutes(start.getMinutes() + 60);

//         const res = await fetch(
//           "https://www.googleapis.com/calendar/v3/calendars/primary/events",
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               summary: `Skilll.dev – Day ${i + 1}`,
//               description: `Learning Day ${i + 1}\nFrontend-only testing`,
//               start: {
//                 dateTime: start.toISOString(),
//               },
//               end: {
//                 dateTime: end.toISOString(),
//               },
//               reminders: {
//                 useDefault: false,
//                 overrides: [{ method: "popup", minutes: 10 }],
//               },
//             }),
//           }
//         );

//         if (!res.ok) {
//           throw new Error("Failed to create calendar event");
//         }

//         createdEvents.push(i + 1);
//       }

//       console.log("Created days:", createdEvents);
//       setStatus("success");
//       setTimeout(() => navigate("/dashboard"), 2500);
//     } catch (err) {
//       console.error(err);
//       setStatus("error");
//       setError("Calendar sync failed. Please try again.");
//     }
//   };

//   return (
//     <Wrapper>
//       {status === "processing" && (
//         <>
//           <h2>Connecting your Google Calendar…</h2>
//           <p>Please wait. This will take a few seconds.</p>
//         </>
//       )}

//       {status === "success" && (
//         <>
//           <h2>✅ Calendar Connected</h2>
//           <p>
//             A test event has been added to your Google Calendar.
//             <br />
//             You’ll be redirected to your dashboard.
//           </p>
//         </>
//       )}

//       {status === "error" && (
//         <>
//           <h2>❌ Calendar Sync Failed</h2>
//           <p>{error}</p>
//           <button onClick={() => navigate("/dashboard")}>
//             Go to Dashboard
//           </button>
//         </>
//       )}
//     </Wrapper>
//   );
// }

// /* ---------------- styles ---------------- */

// const Wrapper = styled.div`
//   min-height: 100vh;
//   background: radial-gradient(
//       800px at 50% 0%,
//       rgba(59, 130, 246, 0.15),
//       transparent 55%
//     ),
//     ${({ theme }) => theme.colors.bg};

//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   text-align: center;
//   padding: 24px;

//   h2 {
//     font-size: 28px;
//     font-weight: 900;
//     margin-bottom: 12px;
//   }

//   p {
//     max-width: 420px;
//     color: ${({ theme }) => theme.colors.textSecondary};
//     font-size: 16px;
//   }

//   button {
//     margin-top: 20px;
//     padding: 12px 22px;
//     border-radius: 14px;
//     border: none;
//     background: ${({ theme }) => theme.colors.primary};
//     color: #fff;
//     font-weight: 800;
//     cursor: pointer;
//   }
// `;

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function GoogleCalendarCallback() {
  const navigate = useNavigate();

  // useEffect(() => {
  //   // Backend will handle everything
  //   // This page is only for UX
  //   setTimeout(() => {
  //     navigate("/dashboard");
  //   }, 2000);
  // }, []);

  return (
    <div style={{ textAlign: "center", paddingTop: 120 }}>
      <h2>🔐 Connecting Google Calendar…</h2>
      <p>Please wait while we finish setting things up.</p>
    </div>
  );
}
